"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceWithApi = void 0;
var inversify_1 = require("inversify");
var ApiField_1 = require("./ApiField");
var ApiThrowsError_1 = require("./ApiThrowsError");
var ServiceWithApi = /** @class */ (function () {
    function ServiceWithApi() {
    }
    Object.defineProperty(ServiceWithApi.prototype, "mapResponseToEntity", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (tToBe) {
            return ApiField_1.createNewEntityFromApiData(this.getGenericConstructor(), tToBe);
        }
    });
    Object.defineProperty(ServiceWithApi.prototype, "adaptList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (data) {
            var _this = this;
            data.items = data.items.map(function (tToBe) { return _this.mapResponseToEntity(tToBe); });
            return data;
        }
    });
    Object.defineProperty(ServiceWithApi.prototype, "readEntity", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (identifier) {
            return __awaiter(this, void 0, void 0, function () {
                var url, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = this.endpointUrl + '/' + identifier;
                            return [4 /*yield*/, this.apiAdapter.get(url)];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, this.mapResponseToEntity(response.data.item)];
                    }
                });
            });
        }
    });
    Object.defineProperty(ServiceWithApi.prototype, "fetchList", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (criteria) {
            return __awaiter(this, void 0, void 0, function () {
                var url, params, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = this.endpointUrl + '/';
                            params = {};
                            params.from = criteria === null || criteria === void 0 ? void 0 : criteria.from;
                            params.to = criteria === null || criteria === void 0 ? void 0 : criteria.to;
                            params.sorts = criteria === null || criteria === void 0 ? void 0 : criteria.sorts;
                            params.filters = criteria === null || criteria === void 0 ? void 0 : criteria.filters;
                            params.selects = criteria === null || criteria === void 0 ? void 0 : criteria.selects;
                            params.includes = criteria === null || criteria === void 0 ? void 0 : criteria.includes;
                            params.search = criteria === null || criteria === void 0 ? void 0 : criteria.search;
                            return [4 /*yield*/, this.apiAdapter.get(url, { params: params })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, this.adaptList(response.data)];
                    }
                });
            });
        }
    });
    Object.defineProperty(ServiceWithApi.prototype, "createEntity", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (model, endpoint) {
            if (endpoint === void 0) { endpoint = '/'; }
            return __awaiter(this, void 0, void 0, function () {
                var dataToSend, url, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dataToSend = ApiField_1.toPlainObject(model);
                            url = this.endpointUrl + endpoint;
                            return [4 /*yield*/, this.apiAdapter.post(url, dataToSend)];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, this.mapResponseToEntity(response.data.item)];
                    }
                });
            });
        }
    });
    Object.defineProperty(ServiceWithApi.prototype, "updateEntity", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (entityIdentifier, model, endpoint) {
            if (endpoint === void 0) { endpoint = '/'; }
            return __awaiter(this, void 0, void 0, function () {
                var dataToSend, url, response;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            dataToSend = ApiField_1.toPlainObject(model);
                            url = this.endpointUrl + '/' + entityIdentifier + endpoint;
                            delete dataToSend['id'];
                            return [4 /*yield*/, this.apiAdapter.put(url, dataToSend)];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, this.mapResponseToEntity(response.data.item)];
                    }
                });
            });
        }
    });
    Object.defineProperty(ServiceWithApi.prototype, "deleteEntity", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (entityIdentifier) {
            return __awaiter(this, void 0, void 0, function () {
                var url;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = this.endpointUrl + '/' + entityIdentifier;
                            return [4 /*yield*/, this.apiAdapter.delete(url)];
                        case 1: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        }
    });
    __decorate([
        ApiThrowsError_1.ApiThrowsError,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, String]),
        __metadata("design:returntype", Promise)
    ], ServiceWithApi.prototype, "createEntity", null);
    __decorate([
        ApiThrowsError_1.ApiThrowsError,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object, String]),
        __metadata("design:returntype", Promise)
    ], ServiceWithApi.prototype, "updateEntity", null);
    __decorate([
        ApiThrowsError_1.ApiThrowsError,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], ServiceWithApi.prototype, "deleteEntity", null);
    ServiceWithApi = __decorate([
        inversify_1.injectable()
    ], ServiceWithApi);
    return ServiceWithApi;
}());
exports.ServiceWithApi = ServiceWithApi;
//# sourceMappingURL=ServiceWithApi.js.map